import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useFormContext } from 'react-hook-form';
import { addDays } from 'date-fns';
import { ScreenAndProtectReservationType } from 'models/ScreenAndProtect';
import DisplayValue from '../common/displayValue/DisplayValue';
import { StyledReservationDetails } from './ReservationDetails.styled';
import ReservationTypeField from './fields/ReservationTypeField';
import ReservationSummary from './ReservationSummary';
import { ScreenAndProtectDetailsFormSchemaType } from './ScreenAndProtectDetails.schema';

const ReservationDetails: FC = () => {
  const { t } = useTranslation();
  const { watch } = useFormContext<ScreenAndProtectDetailsFormSchemaType>();
  const reservationType = watch(
    'reservationType',
  ) as ScreenAndProtectReservationType;
  const startDate = addDays(new Date(), 2);

  return (
    <StyledReservationDetails>
      <DisplayValue
        label={t(
          'pageScreenAndProtect.detailsPage.sections.protectionDetails.reservations',
        )}
        value={<ReservationTypeField />}
        valueDataIntercomTarget="details-screen-protect-reservations"
      />

      <ReservationSummary
        reservationType={reservationType}
        startDate={t('common.dateMedium', { date: startDate })}
      />
    </StyledReservationDetails>
  );
};

export default ReservationDetails;
